import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function shortenWords(word: string, length: number): string {
    if (word.length > length) {
      return `${word.substring(0, length - 1)}...`;
    }
    return word;
  }

  return {
    shortenWords,
  };
}
